import Cookies from "js-cookie";

//客户端key
let clientInfo = {
  "client-id": "expert_client",
  "client-secret": "wCibIu"
  // "client-id": "expert_client",
  // "client-secret": "wCibIu"
};

//点击 "统一身份认证" 跳转的链接
export function getLoginParam() {
  let clientId = clientInfo["client-id"];
  let clientSecret = clientInfo["client-secret"];
  let redirectUrl = window.config.redirectUrl;
  let param =
    "grant_type=authorization_code&client_id=" +
    clientId +
    "&client_secret=" +
    clientSecret +
    "&scop=read&response_type=code&redirect_uri=" +
    redirectUrl;
  return param;
}

//token
const tokenKey = "access_token";
export const getToken = ():any => sessionStorage.getItem(tokenKey);
export const setToken = (token: string):void => sessionStorage.setItem(tokenKey, token);
export const removeToken = ():void => sessionStorage.removeItem(tokenKey);

// 是否加载菜单的标识 
const isLoadMenuFlag = "isLoadMenu"
let currenSeconds = new Date().getTime() // 当前时间
let expiresTime = new Date(currenSeconds + 60 * 1000 * 60) // 失效时间 30分钟
export const getMenuFlag = () => Cookies.get(isLoadMenuFlag);
export const setLoadMenuFlag = (flag:string)=> Cookies.set(isLoadMenuFlag,flag,{ expires: expiresTime})
export const removeMenuFlag = () => Cookies.remove(isLoadMenuFlag);
